// extracted by mini-css-extract-plugin
module.exports = {"sample_maintenance_right_block_wrapper":"RightBlock_sample_maintenance_right_block_wrapper__31JJ9"};